export default __webpack_public_path__ + "images/0x8cf881799e3b5ab24271a9b66b6ca2b0e575b1ef.png";